import React, { Component } from "react";
import Back from "../images/back.svg";
import table from "../images/table.svg";
import takeaway from "../images/takeaway.svg";
import NewFood from "../images/newfood.svg";
import Cancel from "../images/cancel.svg";
import Tick from "../images/tick.svg";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import OrderItem from "../components/OrderItem";
import EditableOrderItem from "../components/EditableOrderItem";
import CustomButton from "../components/CustomButton";
import TableItem from "../components/TableItem";
import Loading from "../components/Loading";
import { WhisperSpinner } from "react-spinners-kit";
import noimage from "../images/noimage.jpg";
import { toast } from "react-toastify";
import ScrollContainer from "react-indiana-drag-scroll";
import plus from "../images/plusPrimary.svg";
import minus from "../images/minusPrimary.svg";
import { Modal } from "react-bootstrap";
import Profile from "./Profile";
import { NumericFormat } from "react-number-format";
import { Form } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Button from "@mui/material/Button";
import momentjalali from "moment-jalaali";

import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  BaseUrlPublic,
  LogoutFunction,
  ServerSocket,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

const mobileRegex = RegExp(/09(0[1-9]|1[0-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class Test extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Cats: [],
      Foods: [],
      catActiveIndex: -1,
      loading: true,
      shoppingList: [],
      searchValue: "",
      totalPrice: 0,
      extrasPrice: 0,
      servicePrice: 0,
      deliveryPrice: 0,
      discountPrice: 0,
      taxPrice: 0,
    };

    // this.searchRef = React.createRef();
  }

  // componentDidUpdate(prevProps,prevState) {
  //   if (prevState.shoppingList!==this.state.shoppingList) invoiceCalculator()
  // }

  invoiceCalculator() {
    // console.log("invoiceCalculator: ", this.state.shoppingList);
    // let newItems = JSON.parse(JSON.stringify(this.state.shoppingList));
    // // newItems.forEach((element) => {
    // //   delete element.foodPicS1;
    // //   delete element.foodPicS2;
    // //   delete element.foodPicS3;
    // //   delete element.descr;
    // //   delete element.nameObj;
    // //   delete element.descrObj;
    // //   delete element.price;
    // //   delete element.id;
    // //   delete element.categoryId;
    // //   delete element.isEnable;
    // //   delete element.priority;
    // //   delete element.name;
    // //   delete element.foodName;
    // //   delete element.orderId;
    // //   delete element.onTax;
    // //   delete element.taxPercent;
    // //   delete element.packingPrice;
    // //   delete element.OPWarning;
    // // });
    // let newmobile = this.state.mobileValue;
    // if (newmobile.startsWith("0")) {
    //   newmobile = newmobile.substring(1);
    //   newmobile = "+98" + newmobile;
    //   newmobile = "+989381407833";
    // }
    // let data = {
    //   orderStationId: Number(this.state.currentorderStationId),
    //   businessId: this.state.resID,
    //   businessCode: this.props.match.params.id,
    //   items: newItems,
    //   discount: 0,
    //   customerMobile: newmobile,
    // };
    // data = Object.assign(data, Authorization());
    // // this.setState({ doneLoading: true });
    // console.log(data);
    // fetch(BaseUrl + "invoiceCalculator", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(data),
    // })
    //   .then((res) => res.json())
    //   .then((result) => {
    //     console.log(result);
    //     if (result.status === 200) {
    //       this.setState(
    //         {
    //           totalPrice: result.invoice.sum,
    //           sum: result.invoice.sum,
    //           sumItem: result.invoice.sumItem,
    //           taxPrice: result.invoice.tax,
    //           servicePrice: result.invoice.service,
    //           packingPrice: result.invoice.packing,
    //           discountPrice: result.invoice.discount,
    //           editView: true,
    //           showMenu: false,
    //           Menu: [],
    //           Foods: [],
    //           ModalInfoShow: false,
    //         },
    //         () => {
    //           // this.updatePrice();
    //         }
    //       );
    //     } else if (result.status === 401) {
    //       LogoutFunction();
    //     } else {
    //       toast.error(result.message, {
    //         position: toast.POSITION.BOTTOM_RIGHT,
    //         hideProgressBar: true,
    //         autoClose: 6000,
    //         toastClassName: "toast",
    //       });
    //     }
    //     this.setState({ doneLoading: false });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     this.setState({ doneLoading: false });
    //   });
  }

  componentDidMount() {
    let data = {
      type: "getMenuWithBusinessCode",
      languageId: this.state.defaultLanguage,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getMenu:", result);
        if (result.status === 200) {
          if (result.result.length > 0) {
            let menu = JSON.parse(JSON.stringify(result.result));
            menu.forEach((element) => {
              let catname = "";
              element.nameObj.forEach((element1) => {
                if (element1.languageId === 1) {
                  catname = element1.name;
                }
              });

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (element1.languageId === this.state.defaultLanguage) {
                    catname = element1.name;
                  }
                });
              }

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (catname === "" && element1.name !== "") {
                    catname = element1.name;
                  }
                });
              }
              element.name = catname;

              element.items.forEach((element2) => {
                let itemname = "";
                let itemdescr = "";

                element2.nameObj.forEach((element3) => {
                  if (element3.languageId === 1) {
                    itemname = element3.name;
                  }
                });
                if (itemname === "") {
                  element2.nameObj.forEach((element3) => {
                    if (element3.languageId === this.state.defaultLanguage) {
                      itemname = element3.name;
                    }
                  });
                }

                if (itemname === "") {
                  element2.nameObj.forEach((element3) => {
                    if (itemname === "" && element3.name !== "") {
                      itemname = element3.name;
                    }
                  });
                }
                element2.descrObj.forEach((element3) => {
                  if (element3.languageId === 1) {
                    itemdescr = element3.descr;
                  }
                });
                if (itemdescr === "") {
                  element2.descrObj.forEach((element3) => {
                    if (element3.languageId === this.state.defaultLanguage) {
                      itemdescr = element3.descr;
                    }
                  });
                }
                if (itemdescr === "") {
                  element2.descrObj.forEach((element3) => {
                    if (itemdescr === "" && element3.descr !== "") {
                      itemdescr = element3.descr;
                    }
                  });
                }
                element2.descr = itemdescr;

                element2.name = itemname;
              });
            });

            this.setState({ Cats: menu, catActiveIndex: -1 }, () => {
              console.log(menu);
              // this.updateMenu(result.result[0].id);
            });
          }
        } else if (result.status === 401) {
          LogoutFunction();
        }

        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  categoryClick(i, id) {
    this.setState({ catActiveIndex: i });
    this.updateMenu(id);
  }

  updateMenu(id) {
    this.state.Cats.forEach((element) => {
      if (element.id === id) {
        let foods = element.items;
        this.setState({ Foods: foods });
      }
    });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    if (!this.state.loading) {
      return (
        <div className="Login">
          <div
            style={{
              width: "100%",
              height: "60px",
              border: "2px solid var(--brown1)",
              borderWidth: "0px 0px 2px 0px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0px 10px",
            }}
          >
            <div style={{ flex: "1" }}>
              <Form.Control
                className="inputStyleForm textAlignCenter"
                placeholder="جستجو"
                style={{ maxWidth: "300px", width: "100%", direction: "rtl" }}
                type="text"
                name="searchValue"
                onChange={(e) => {
                  this.setState({ searchValue: e.target.value }, () => {
                    let foods = [];
                    this.setState({ catActiveIndex: -1 });
                    if (this.state.searchValue)
                      this.state.Cats.forEach((element) => {
                        element.items.forEach((element1) => {
                          if (
                            element1.name
                              .toLowerCase()
                              .indexOf(this.state.searchValue.toLowerCase()) >
                            -1
                          ) {
                            foods.push(element1);
                          }
                        });
                      });
                    else foods = [];

                    this.setState({ Foods: foods });
                  });
                }}
                value={this.state.searchValue}
              />
            </div>

            <div style={{ flex: "1", textAlign: "center" }}>حسن شماعی زاده</div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                flex: "1",
              }}
            >
              <div>{momentjalali().format("jYYYY/jM/jD")}</div>
              <div>{momentjalali().format("HH:mm")}</div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "calc(100vh - 120px)",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                height: "calc(100vh - 120px)",
                flex: "1",
                justifyContent: "center",
                alignItems:
                  this.state.Foods.length > 0 ? "flex-start" : "center",
              }}
            >
              {this.state.Foods.length === 0 && (
                <div style={{ color: "var(--black2)" }}>
                  لطفاً یک دسته را انتخاب کنید
                </div>
              )}
              {this.state.Foods.length > 0 && (
                <div
                  className="foodsContainer"
                  style={{
                    flex: "1",
                    height: "fit-content",
                    overflowY: "auto",
                    // height: "calc(100vh - 120px)",
                    maxHeight: "calc(100vh - 120px)",
                  }}
                >
                  {this.state.Foods.map((item, i) => {
                    return (
                      <Button
                        key={i}
                        variant="outlined"
                        style={{
                          height: "100px",
                          width: "170px",
                          borderWidth: "4px",
                        }}
                        onClick={() => {
                          let list = JSON.parse(
                            JSON.stringify(this.state.shoppingList)
                          );

                          let found = false;
                          list.forEach((element) => {
                            if (element.id === item.id) {
                              found = true;
                              element.quantity = element.quantity + 1;
                            }
                          });

                          if (!found) {
                            let obj = item;
                            obj.quantity = 1;
                            list.push(obj);
                          }

                          this.setState({ shoppingList: list });

                          // let foods = this.state.Foods;

                          // foods.forEach((element) => {
                          //   if (element.id === item.id) {
                          //     if (
                          //       element.quantity === undefined ||
                          //       isNaN(element.quantity) ||
                          //       element.quantity === 0
                          //     ) {
                          //       element.quantity = 1;
                          //     } else {
                          //       element.quantity = element.quantity + 1;
                          //     }
                          //   }
                          // });

                          // this.setState({ Foods: foods });
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ wordBreak: "break-word" }}>
                            {item.name}
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <NumericFormat
                              allowNegative={true}
                              value={item.price}
                              displayType={"text"}
                              thousandSeparator={true}
                            />
                            <div>&nbsp;$$$</div>
                          </div>
                        </div>
                      </Button>
                    );
                  })}
                </div>
              )}
            </div>
            <div
              style={{
                width: "200px",
                border: "1px solid var(--brown1)",
                borderWidth: "0px 2px 0px 2px",
                overflowY: "auto",
                padding: "5px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {this.state.Cats.map((item, index) =>
                item.isEnable ? (
                  <div
                    key={index}
                    onClick={this.categoryClick.bind(this, index, item.id)}
                  >
                    <div
                      style={{
                        width: "100%",
                        minHeight: "80px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        userSelect: "none",
                        border: "2px solid var(--brown1)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        backgroundColor:
                          this.state.catActiveIndex === index
                            ? "var(--brown1)"
                            : "transparent",
                        color:
                          this.state.catActiveIndex === index
                            ? "white"
                            : "black",
                      }}
                    >
                      {item.name}
                    </div>
                  </div>
                ) : null
              )}
            </div>
            <div
              style={{
                flex: "1",
                height: "fit-content",
                // overflowY: "auto",
                height: "calc(100vh - 120px)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "1",
                  gap: "10px",
                  // padding: "10px",
                  justifyContent: this.state.shoppingList.length
                    ? "flex-start"
                    : "center",
                  alignItems: "center",
                  minHeight: "10px",
                }}
              >
                {this.state.shoppingList.length === 0 && (
                  <div style={{ color: "var(--black2)" }}>
                    سبد خرید خالی است
                  </div>
                )}
                {this.state.shoppingList.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: "1",
                      gap: "10px",
                      width: "100%",
                      overflowY: "auto",
                      padding: "10px",
                    }}
                  >
                    {this.state.shoppingList.map((item, i) => {
                      return (
                        <div
                          style={{
                            gap: "10px",
                            width: "100%",
                            minHeight: "50px",
                            borderRadius: "10px",
                            backgroundColor: "var(--brown1)",
                            minHeight: "60px",
                            display: "flex",
                            flexDirection: "row",
                            padding: "5px 10px",
                            color: "white",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              borderRadius: "50%",
                              border: "1px solid white",
                              color: "white",
                              width: "30px",
                              height: "30px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              paddingTop: "2px",
                            }}
                          >
                            {i + 1}
                          </div>
                          <div style={{ flex: "1.5", textAlign: "right" }}>
                            {item.name}
                          </div>
                          {/* <div style={{ flex: "0.5" }} /> */}
                          <div
                            className="plusminus1"
                            onClick={() => {
                              let list = JSON.parse(
                                JSON.stringify(this.state.shoppingList)
                              );

                              let found = false;
                              list.forEach((element) => {
                                if (element.id === item.id) {
                                  element.quantity = element.quantity + 1;
                                }
                              });

                              this.setState({ shoppingList: list });
                            }}
                          >
                            <img
                              src={plus}
                              style={{
                                width: "55%",
                                height: "55%",
                                objectFit: "contain",
                                color: "red",
                              }}
                              alt=""
                            />
                          </div>
                          {item.quantity}

                          <div
                            className="plusminus1"
                            onClick={() => {
                              let list = JSON.parse(
                                JSON.stringify(this.state.shoppingList)
                              );

                              let found = false;
                              list.forEach((element) => {
                                if (element.id === item.id) {
                                  if (element.quantity > 1)
                                    element.quantity = element.quantity - 1;
                                }
                              });

                              this.setState({ shoppingList: list });
                            }}
                          >
                            <img
                              src={minus}
                              style={{
                                width: "55%",
                                height: "2px",
                                objectFit: "contain",
                                color: "red",
                              }}
                              alt=""
                            />
                          </div>
                          <div style={{ flex: "0.2" }} />

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              // backgroundColor: "red",
                              minWidth: "120px",
                              justifyContent: "flex-end",
                            }}
                          >
                            <NumericFormat
                              allowNegative={true}
                              value={
                                item.quantity
                                  ? item.quantity * item.price
                                  : item.price
                              }
                              // value={100000000}
                              displayType={"text"}
                              thousandSeparator={true}
                            />
                            <div>&nbsp;$$$</div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "20px",
                              height: "20px",
                              border: "2px solid white",
                              borderRadius: "50%",
                              cursor: "pointer",
                              userSelect: "none",
                            }}
                            onClick={() => {
                              let list = JSON.parse(
                                JSON.stringify(this.state.shoppingList)
                              );
                              list.splice(i, 1);
                              this.setState({ shoppingList: list });
                            }}
                          >
                            <img
                              src={Cancel}
                              alt="cancel"
                              style={{ width: "8px" }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {this.state.shoppingList.length > 0 && (
                  <div
                    style={{
                      padding: "10px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="factureResultRow">
                      <div>جمع فاکتور:</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          minWidth: "120px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <NumericFormat
                          allowNegative={true}
                          value={() => {}}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        <div>&nbsp;$$$</div>
                      </div>
                    </div>
                    <div className="factureResultRow">
                      <div>اضافات:</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          minWidth: "120px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <NumericFormat
                          allowNegative={true}
                          value={() => {
                            try {
                              if (this.state.shoppingList.length > 0) {
                                let total = 0;
                                this.state.shoppingList.forEach((element) => {
                                  total += element.quantity * element.price;
                                });
                                return total;
                              } else return 0;
                            } catch (error) {
                              return 0;
                            }
                          }}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        <div>&nbsp;$$$</div>
                      </div>
                    </div>
                    <div className="factureResultRow">
                      <div>سرویس:</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          minWidth: "120px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <NumericFormat
                          allowNegative={true}
                          value={() => {
                            try {
                              if (this.state.shoppingList.length > 0) {
                                let total = 0;
                                this.state.shoppingList.forEach((element) => {
                                  total += element.quantity * element.price;
                                });
                                return total;
                              } else return 0;
                            } catch (error) {
                              return 0;
                            }
                          }}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        <div>&nbsp;$$$</div>
                      </div>
                    </div>
                    <div className="factureResultRow">
                      <div>حمل:</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          minWidth: "120px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <NumericFormat
                          allowNegative={true}
                          value={() => {
                            try {
                              if (this.state.shoppingList.length > 0) {
                                let total = 0;
                                this.state.shoppingList.forEach((element) => {
                                  total += element.quantity * element.price;
                                });
                                return total;
                              } else return 0;
                            } catch (error) {
                              return 0;
                            }
                          }}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        <div>&nbsp;$$$</div>
                      </div>
                    </div>
                    <div className="factureResultRow">
                      <div>تخفیف:</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          minWidth: "120px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <NumericFormat
                          allowNegative={true}
                          value={() => {
                            try {
                              if (this.state.shoppingList.length > 0) {
                                let total = 0;
                                this.state.shoppingList.forEach((element) => {
                                  total += element.quantity * element.price;
                                });
                                return total;
                              } else return 0;
                            } catch (error) {
                              return 0;
                            }
                          }}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        <div>&nbsp;$$$</div>
                      </div>
                    </div>
                    <div className="factureResultRow">
                      <div>مالیات:</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          minWidth: "120px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <NumericFormat
                          allowNegative={true}
                          value={() => {}}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        <div>&nbsp;$$$</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  gap: "5px",
                  padding: "10px",
                  border: "4px solid var(--black1)",
                  borderWidth: "4px 0 0 0",
                }}
              >
                <CustomButton title="ثبت فاکتور" minHeight="80px" />
                <CustomButton title="چاپ فاکتور" minHeight="80px" />
                <CustomButton title="چاپ سفارش" minHeight="80px" />
                <CustomButton title="تسویه" minHeight="80px" />
                <CustomButton title="تسویه" minHeight="80px" />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "60px",
              border: "2px solid var(--brown1)",
              borderWidth: "2px 0px 0px 0px",
              display: "flex",
              flexDirection: "row",
              position: "absolute",
              bottom: "0",
              left: "0",
            }}
          ></div>
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
